import { Alert } from '@mui/material';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import AdGroupForm from '../components/AdGroups/AdGroupForm';
import AdGroupSkeleton from '../components/AdGroups/AdGroupSkeleton';
import useContract from '../hooks/useContract';
import useNewAdGroup from '../hooks/useNewAdGroup';

function NewAdGroupPage() {
  const params = useParams();
  const location = useLocation();
  const activeTab = location.hash.substring(1);
  const lineItemId = Number(params.lineItemId);
  const newAdGroup = useNewAdGroup(lineItemId);
  const contract = useContract(parseInt(params.id, 10));

  if (newAdGroup.isLoading || contract.isLoading) {
    return <AdGroupSkeleton />;
  }

  if (newAdGroup.isError) {
    return <Alert severity="error">Failed to load Ad Group</Alert>;
  }

  return <AdGroupForm adGroup={newAdGroup.data} contract={contract.data} activeTab={activeTab} />;
}

export default NewAdGroupPage;
